var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 30.14L25.3234 21.28C24.7084 20.9275 23.9534 20.9275 23.3384 21.28L7.83836 30.14C7.16586 30.525 7.16586 31.4925 7.83836 31.8775L23.3434 40.7375C23.9584 41.09 24.7134 41.09 25.3284 40.7375L40.8334 31.8775C41.5059 31.4925 41.5059 30.525 40.8334 30.14H40.8284Z",
    fill: "#A5D8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 30.14L25.3234 21.28C24.7084 20.9275 23.9534 20.9275 23.3384 21.28L7.83836 30.14C7.16586 30.525 7.16586 31.4925 7.83836 31.8775L23.3434 40.7375C23.9584 41.09 24.7134 41.09 25.3284 40.7375L40.8334 31.8775C41.5059 31.4925 41.5059 30.525 40.8334 30.14H40.8284Z",
    fill: "#CCECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 23.1322L25.3234 14.2722C24.7084 13.9197 23.9534 13.9197 23.3384 14.2722L7.83836 23.1322C7.16586 23.5172 7.16586 24.4847 7.83836 24.8697L23.3434 33.7297C23.9584 34.0822 24.7134 34.0822 25.3284 33.7297L40.8334 24.8697C41.5059 24.4847 41.5059 23.5172 40.8334 23.1322H40.8284Z",
    fill: "#4DABF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 23.1322L25.3234 14.2722C24.7084 13.9197 23.9534 13.9197 23.3384 14.2722L7.83836 23.1322C7.16586 23.5172 7.16586 24.4847 7.83836 24.8697L23.3434 33.7297C23.9584 34.0822 24.7134 34.0822 25.3284 33.7297L40.8334 24.8697C41.5059 24.4847 41.5059 23.5172 40.8334 23.1322H40.8284Z",
    fill: "#52C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 16.1224L25.3259 7.26242C24.7109 6.90992 23.9559 6.90992 23.3409 7.26242L7.83836 16.1224C7.16586 16.5074 7.16586 17.4749 7.83836 17.8599L23.3434 26.7199C23.9584 27.0724 24.7134 27.0724 25.3284 26.7199L40.8334 17.8599C41.5059 17.4749 41.5059 16.5074 40.8334 16.1224H40.8284Z",
    fill: "#228BE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 16.1224L25.3259 7.26242C24.7109 6.90992 23.9559 6.90992 23.3409 7.26242L7.83836 16.1224C7.16586 16.5074 7.16586 17.4749 7.83836 17.8599L23.3434 26.7199C23.9584 27.0724 24.7134 27.0724 25.3284 26.7199L40.8334 17.8599C41.5059 17.4749 41.5059 16.5074 40.8334 16.1224H40.8284Z",
    fill: "#2CA4FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResume);
export default __webpack_public_path__ + "static/media/icon_resume.ea539d41.svg";
export { ForwardRef as ReactComponent };